import gql from 'graphql-tag';

const VALIDATED_NATIONAL_ID = gql`
    query validatedNationalId(
        $nationalId: String
        $countryCode: String
        $listingCountryCode: String
        $required: Boolean
    ) {
        validatedNationalId(
            nationalId: $nationalId
            countryCode: $countryCode
            listingCountryCode: $listingCountryCode
            required: $required
        ) {
            value
            error
        }
    }
`;

export default VALIDATED_NATIONAL_ID;
